// extracted by mini-css-extract-plugin
export default {"newPlanWrapper":"ViewTab_newPlanWrapper__T9drG"};